export const formatAmount = (amount: string): string => {
  if (!amount || isNaN(Number(amount)) || amount.trim() === "") return amount;

  let formattedAmount = amount.trim();
  let [integerPart = "", decimalPart = ""] = formattedAmount.split(".");

  if (decimalPart === undefined || decimalPart === "") {
    decimalPart = "00";
  } else if (decimalPart.length === 1) {
    decimalPart = decimalPart + "0";
  } else if (decimalPart.length > 2) {
    decimalPart = decimalPart.slice(0, 2);
  }

  return `${integerPart}.${decimalPart}`;
};

export const removeEmojis = (str: string): string => {
  return str.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\u24C2|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDFFF])/g, "");
};

export const getCategoryInitials = (categoryName: string): string => {
  const words = categoryName.trim().split(/\s+/);
  if (words.length === 1) {
    return words[0].substring(0, 5).toUpperCase();
  } else {
    return words.map((word) => word[0].toUpperCase()).join("");
  }
};
